<template>
  <div class="monitor1" v-show="falg">
    <div class="close" @click="videoPause"></div>
    <video class="video" src="../video/4.mp4" style="object-fit: fill" muted autoplay controls loop></video>
    <div class="video-bg"></div>
    <div class="video-yy"></div>
  </div>
</template>

<script>

  export default {
    name: "video",
    data() {
      return {
        hls: '',
        falg: false
      }
    },
    mounted() {
      window.videoPlay = this.paly;
    },
    methods: {
      paly() {
        this.falg = true;
      },
      //视频关闭
      videoPause() {
        this.falg = false;

      },
    }
  }
</script>

<style scoped>
  .video-yy {
    width: 328px;
    height: 185px;
    background: black;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .video-bg {
    position: absolute;
    background: url("./../assets/video-bg.png") no-repeat;
    background-size: 100% 100%;
    width: 334px;
    height: 198px;
    z-index: 999;
    pointer-events: none;
  }

  .video {
    width: 328px;
    height: 185px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
  }

  .monitor1 {
    width: 334px;
    height: 198px;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .close {
    width: 10px;
    height: 10px;
    background: url("./../assets/close.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 9px;
    right: 9px;
    cursor: pointer;
    z-index: 999;
  }

  #videoPlay {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .mask {
    position: absolute;
    width: 100%;
    height: 20%;
    background: transparent;
    top: 0;
  }
</style>
